<template>
    <div>
        สต๊อคคงเหลือ
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>